export const GCP_FUNCTION_URL =
  "https://australia-southeast1-profound-shell-278600.cloudfunctions.net"
// export const GCP_FUNCTION_URL_STAGING = "http://localhost:8080"
